import { Grid, TextField } from "@mui/material"
import { useState } from "react"
import Modal from "../ui/Modal"

const initialData = {
  accountNumber: "",
  branchName: "",
  ifsc: "",
  bankName: "",
}

const AddEmployeeAccount = (props) => {
  const [data, setData] = useState(initialData)
  const handleChange = (e) => {
    const { name, value } = e.target
    setData({
      ...data,
      [name]: value,
    })
  }
  const action = () => {
    props.add(data)
    setData(initialData)
    props.close()
  }
  return (
    <Modal
      {...props}
      title="Add Account"
      actionText={"Add"}
      action={action}
    >
      <Grid container spacing={2} mt={1}>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Account Number"
            name="accountNumber"
            value={data.accountNumber}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Branch Name"
            name="branchName"
            value={data.branchName}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="IFSC Code"
            name="ifsc"
            value={data.ifsc}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Bank Name"
            name="bankName"
            value={data.bankName}
            onChange={handleChange}
          />
        </Grid>
      </Grid>
    </Modal>
  )
}

export default AddEmployeeAccount
